import * as React from 'react'

import { baseIntegrationImgSrc, circleCheckImg } from '../../shared'
import IntegrationTip from '../integration_tip'
import { getPageTitle } from '../../../Shared'

const googleIconSrc = `${baseIntegrationImgSrc}/google_logo.svg`

const GoogleIntegrationContainer = () => {
  document.title = getPageTitle("Premium Hub", "Integrations | Google Classroom")
  return (
    <div className="container">
      <section aria-labelledby="googleIntegrationContainerTitle" className="integration-container">
        <img alt="" className="logo" src={googleIconSrc} />
        <h2 id="googleIntegrationContainerTitle">Streamline teaching with Google Classroom</h2>
        <p>Make teaching at your school even more effective with our seamless Google Classroom integration. With this integration, teachers at your school or district can:</p>
        <ul>
          <li>{circleCheckImg}Seamlessly import Google Classroom rosters.</li>
          <li>{circleCheckImg}Automatically create and sync Google Classroom student accounts.</li>
          <li>{circleCheckImg}Share assignments directly to Google Classroom.</li>
        </ul>
        <div className="links">
          <a className="focus-on-light" href="https://support.quill.org/en/articles/8500172-how-to-choose-your-rostering-integration" rel="noopener noreferrer" target="_blank">How to choose your integration</a>
          <a className="focus-on-light" href="https://support.quill.org/en/articles/8470129-how-do-i-facilitate-the-google-classroom-integration-for-my-school-district" rel="noopener noreferrer" target="_blank">How to set up this integration</a>
        </div>
        <IntegrationTip />
      </section>
    </div>
  )

}

export default GoogleIntegrationContainer
